import { __extends } from "tslib";
import { UpdateTemplateActiveVersionRequest, UpdateTemplateActiveVersionResponse } from "../models/index";
import { deserializeAws_restJson1UpdateTemplateActiveVersionCommand, serializeAws_restJson1UpdateTemplateActiveVersionCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateTemplateActiveVersionCommand = /** @class */ (function (_super) {
    __extends(UpdateTemplateActiveVersionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateTemplateActiveVersionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateTemplateActiveVersionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: UpdateTemplateActiveVersionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: UpdateTemplateActiveVersionResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateTemplateActiveVersionCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1UpdateTemplateActiveVersionCommand(input, context);
    };
    UpdateTemplateActiveVersionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1UpdateTemplateActiveVersionCommand(output, context);
    };
    return UpdateTemplateActiveVersionCommand;
}($Command));
export { UpdateTemplateActiveVersionCommand };
//# sourceMappingURL=UpdateTemplateActiveVersionCommand.js.map